import React, { FC } from "react";
import Link from "next/link";
import removeMd from "remove-markdown";
import SocialButtons from "components/blog/socialbuttons";
import { toLocaleDateString } from "helpers";
import { LazyImage } from "components/shared/LazyImage/LazyImage";
import { BlogPostType } from "components/blog/BlogTypes";
import Styles from "./global.scss";

type Props = {
    post: BlogPostType;

    includeLink?: boolean;
    layout?: "hero" | "medium" | "thumbnail";
    showSocial?: boolean;
};

const BlogEntryTeaser: FC<Props> = ({
    layout = "medium",
    showSocial = false,
    post,
    includeLink = true
}) => {
    let width = 0;
    switch (layout) {
        case "hero":
            width = 970;
            break;
        case "thumbnail":
            width = 247;
            break;
        default:
            width = 320;
    }

    const imageContainerClassName =
        layout === "hero" ? "main-item__img hero-image" : "main-item__img";

    const postDiv = (
        <>
            {post.imageSrc && (
                <div key={`Image-src-${post.id}`} className={imageContainerClassName}>
                    <LazyImage
                        src={`${post.imageSrc}?w=${width}&fit=scale`}
                        alt={post.title}
                        style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "cover"
                        }}
                    />
                </div>
            )}
            <div key={`main-item-description-${post.id}`} className="main-item__description">
                {post.categories && post.categories.length && (
                    <div className="main-item__title">
                        <h1>
                            <b>
                                {!includeLink ? (
                                    <Link
                                        as={`/blog/${post.categories[0].slug}`}
                                        href={`/blog/search?category=${post.categories[0].slug}`}
                                    >
                                        <a>{post.categories[0].name}</a>
                                    </Link>
                                ) : (
                                    post.categories[0].name
                                )}
                            </b>{" "}
                            {post.title}
                        </h1>
                    </div>
                )}
                {includeLink && (
                    <div className="main-item__text">
                        <p>{removeMd(post.content).substring(0, 200)}</p>
                        <span className="show-more-btn">lees verder »</span>
                    </div>
                )}

                {post.author && (
                    <div className="main-item__author">
                        {post.author.slug ? (
                            <b>
                                <a href={`/${post.author.slug}`}>{post.author.display_name}</a>
                            </b>
                        ) : (
                            <b>{post.author.display_name}</b>
                        )}
                    </div>
                )}

                {post.publishDate && (
                    <div className="main-item__date">
                        <p>{toLocaleDateString(post.publishDate, "LL")}</p>
                    </div>
                )}
            </div>
        </>
    );

    const pageClasses = "main-item blog-entry-teaser";

    return (
        <div className={layout === "hero" ? `${pageClasses} main-item--hero` : pageClasses}>
            <style jsx>{Styles}</style>

            {includeLink && post.categories && post.categories.length ? (
                <a
                    href={`/blog/${post.categories[0].slug}/${post.slug}`}
                    className="main-item__card"
                >
                    {postDiv}
                </a>
            ) : (
                postDiv
            )}

            {showSocial && post.categories && post.categories.length && (
                <SocialButtons
                    text={post.title}
                    url={`https://www.autotrack.nl/blog/${post.categories[0].slug}/${post.slug}`}
                />
            )}
        </div>
    );
};

export default BlogEntryTeaser;
